import _styled from "styled-components";
import type { SanityCaseStudyCard } from "@ouster/shared";
import { takeFirst } from "~/features/app/utils";
import { formatCaseStudyDate } from "~/features/date/utils";
import { formatCaseStudyLocation } from "~/features/case-study/case-study-meta";
import { Tag } from "~/features/ui/tag";
type Props = {
  postDate?: SanityCaseStudyCard["postDate"];
  locations?: SanityCaseStudyCard["locations"];
};

/**
 * Date and location tag row above a Case Studies listing card headline. Both
 * tags are optional: some case studies carry no location at all.
 */
export function CaseStudyMetaTags({
  postDate,
  locations
}: Props) {
  const date = postDate ? formatCaseStudyDate(postDate) : null;
  const location = formatCaseStudyLocation(takeFirst(locations));
  if (!date && !location) {
    return null;
  }
  return <_StyledUl>
      {date && <Tag as="li">{date}</Tag>}
      {location && <Tag as="li">{location}</Tag>}
    </_StyledUl>;
}
var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  displayName: "case-study-meta-tags___StyledUl",
  componentId: "sc-103gtsh-0"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.4rem"
});